import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCollaborationPointerLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="collaboration-pointer-left, cursor, agents"><path d="M12 12L19.25 9.41071L4.75 4.75L9.41071 19.25L12 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M21.75 13.25L15.375 15.375L13.25 21.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCollaborationPointerLeft;
